/** 注入全局样式（工具栏 / 完成弹层 / 基础布局）。M3 会扩充拟真木纹质感。 */
export function injectStyles(): void {
  if (document.getElementById('pintu-styles')) return;
  const style = document.createElement('style');
  style.id = 'pintu-styles';
  style.textContent = `
    *{box-sizing:border-box;}
    html,body{margin:0;height:100%;background:#1a120b;overflow:hidden;
      font-family:system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;color:#f3e9d8;}
    #app{position:fixed;inset:0;}
    canvas.pintu-canvas{display:block;touch-action:none;}

    .pintu-toolbar{position:fixed;top:0;left:0;right:0;height:56px;display:flex;align-items:center;
      gap:12px;padding:0 14px;z-index:10;
      background:linear-gradient(180deg,rgba(40,28,18,.96),rgba(28,19,12,.92));
      border-bottom:1px solid rgba(255,255,255,.08);
      box-shadow:0 2px 10px rgba(0,0,0,.4);backdrop-filter:blur(6px);
      -webkit-backdrop-filter:blur(6px);user-select:none;}
    .pintu-toolbar .grp{display:flex;align-items:center;gap:6px;}
    .pintu-toolbar label{font-size:12px;opacity:.75;}
    .pintu-toolbar select,.pintu-toolbar button{
      background:rgba(255,255,255,.08);color:#f3e9d8;border:1px solid rgba(255,255,255,.14);
      border-radius:8px;padding:6px 10px;font-size:13px;cursor:pointer;transition:background .15s;}
    .pintu-toolbar select:hover,.pintu-toolbar button:hover{background:rgba(255,255,255,.16);}
    .pintu-toolbar button.primary{background:#c8792b;border-color:#e09a3f;}
    .pintu-toolbar .stat{font-variant-numeric:tabular-nums;font-size:13px;min-width:64px;}
    .pintu-toolbar .stat b{font-weight:600;}
    .pintu-toolbar .spacer{flex:1;}
    .pintu-toolbar input[type=checkbox]{width:16px;height:16px;accent-color:#e09a3f;}
    .pintu-progress{width:90px;height:6px;background:rgba(255,255,255,.12);border-radius:4px;overflow:hidden;}
    .pintu-progress > i{display:block;height:100%;background:#e09a3f;width:0;transition:width .2s;}

    .pintu-status{display:flex;align-items:center;gap:14px;}
    .pintu-stat-line{display:flex;align-items:center;gap:5px;font-size:13px;font-variant-numeric:tabular-nums;}
    .pintu-stat-line b{font-weight:600;}
    .pintu-counts{opacity:.8;font-size:11px;margin-left:3px;}
    .pintu-progress-wrap{display:flex;align-items:center;}
    .pintu-actions{display:flex;align-items:center;gap:8px;}
    .pintu-actions .pintu-act{background:rgba(255,255,255,.08);color:#f3e9d8;border:1px solid rgba(255,255,255,.14);
      border-radius:8px;padding:6px 12px;font-size:13px;cursor:pointer;transition:background .15s;white-space:nowrap;}
    .pintu-actions .pintu-act:hover{background:rgba(255,255,255,.16);}
    .pintu-actions .pintu-act:disabled{opacity:.4;cursor:not-allowed;}

    .pintu-overlay{position:fixed;inset:0;z-index:50;display:flex;align-items:center;justify-content:center;
      background:rgba(0,0,0,.6);backdrop-filter:blur(4px);}
    .pintu-overlay[hidden]{display:none;}
    .pintu-card{background:linear-gradient(180deg,#3a2a1a,#2a1d12);border:1px solid rgba(255,255,255,.12);
      border-radius:16px;padding:28px 34px;text-align:center;max-width:90vw;position:relative;
      box-shadow:0 20px 60px rgba(0,0,0,.6);}
    .pintu-card h2{margin:0 0 6px;font-size:24px;color:#ffd9a0;}
    .pintu-card .sub{opacity:.8;margin-bottom:16px;}
    .pintu-card .nums{display:flex;gap:24px;justify-content:center;margin-bottom:18px;}
    .pintu-card .nums div{display:flex;flex-direction:column;}
    .pintu-card .nums b{font-size:26px;color:#fff;}
    .pintu-card .nums span{font-size:11px;opacity:.7;}
    .pintu-card .best{color:#ffd54a;font-weight:600;margin-bottom:14px;}
    .pintu-card button{background:#c8792b;color:#fff;border:none;border-radius:10px;
      padding:10px 22px;font-size:15px;cursor:pointer;}
    .pintu-card .actions{display:flex;gap:10px;justify-content:center;margin-top:8px;}
    .pintu-card .actions button{flex:none;}
    .pintu-sr{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;}

    .pintu-preview{position:fixed;inset:0;z-index:40;display:flex;align-items:flex-end;justify-content:center;
      padding-bottom:48px;pointer-events:none;}
    .pintu-preview[hidden]{display:none;}
    .pintu-preview-card{background:linear-gradient(180deg,#3a2a1a,#2a1d12);border:1px solid rgba(255,255,255,.14);
      border-radius:14px;padding:16px 22px;text-align:center;box-shadow:0 12px 40px rgba(0,0,0,.5);
      pointer-events:auto;animation:pintu-pop .3s ease;}
    .pintu-preview-title{font-size:20px;font-weight:700;color:#ffd9a0;}
    .pintu-preview-sub{font-size:13px;opacity:.75;margin:4px 0 12px;}
    .pintu-preview-card button{background:#c8792b;color:#fff;border:none;border-radius:9px;padding:9px 22px;font-size:14px;cursor:pointer;}
    .pintu-preview-card button:hover{background:#e09a3f;}
    @keyframes pintu-pop{from{transform:translateY(20px);opacity:0;}to{transform:translateY(0);opacity:1;}}
    .pintu-close{position:absolute;top:10px;right:12px;width:30px;height:30px;border-radius:50%;
      background:rgba(255,255,255,.12);color:#fff;border:none;font-size:18px;line-height:1;cursor:pointer;}
    .pintu-close:hover{background:rgba(255,255,255,.24);}

    .pintu-toast{position:fixed;left:50%;bottom:24px;transform:translate(-50%,16px);
      background:rgba(40,20,12,.95);color:#fff;padding:10px 18px;border-radius:10px;
      border:1px solid rgba(255,255,255,.14);font-size:14px;opacity:0;pointer-events:none;
      transition:opacity .2s,transform .2s;z-index:60;max-width:80vw;}
    .pintu-toast.show{opacity:1;transform:translate(-50%,0);}

    .pintu-gallery{position:fixed;left:0;right:0;bottom:0;display:flex;gap:8px;padding:10px 14px;
      z-index:9;justify-content:center;background:linear-gradient(0deg,rgba(20,14,9,.92),transparent);
      pointer-events:none;}
    .pintu-gallery .thumb{pointer-events:auto;width:88px;height:58px;border-radius:8px;overflow:hidden;
      border:2px solid rgba(255,255,255,.2);cursor:pointer;background:#000;padding:0;flex:none;}
    .pintu-gallery .thumb img{width:100%;height:100%;object-fit:cover;display:block;}
    .pintu-gallery .thumb.active{border-color:#e09a3f;box-shadow:0 0 0 2px rgba(224,154,63,.45);}
    .pintu-gallery .thumb.upload{color:#fff;font-size:26px;font-weight:300;
      display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.08);}

    .pintu-settings-card{padding:22px 22px 18px;min-width:280px;max-width:92vw;}
    .pintu-settings-card h3{margin:0 0 10px;font-size:18px;color:#ffd9a0;text-align:center;}
    .pintu-settings-row{display:flex;align-items:center;justify-content:space-between;gap:12px;
      padding:12px 0;border-bottom:1px solid rgba(255,255,255,.08);}
    .pintu-settings-row:last-child{border-bottom:none;}
    .pintu-settings-row > span{font-size:14px;}
    .pintu-settings-toggle{padding:8px 14px;border-radius:8px;background:rgba(255,255,255,.08);
      border:1px solid rgba(255,255,255,.14);color:#f3e9d8;cursor:pointer;font-size:13px;min-width:96px;}
    .pintu-theme-btns{display:flex;gap:6px;flex-wrap:wrap;justify-content:flex-end;}
    .pintu-theme-btns button{padding:7px 12px;border-radius:8px;background:rgba(255,255,255,.08);
      border:1px solid rgba(255,255,255,.14);color:#f3e9d8;cursor:pointer;font-size:13px;}
    .pintu-theme-btns button.active{background:#c8792b;border-color:#e09a3f;color:#fff;}
    .pintu-settings-share{width:100%;padding:11px;border-radius:9px;background:#c8792b;
      border:none;color:#fff;cursor:pointer;font-size:14px;}

    /* 难度分段按钮 */
    .pintu-seg{display:inline-flex;background:rgba(255,255,255,.08);border-radius:9px;padding:3px;gap:2px;flex-wrap:wrap;}
    .pintu-seg button{padding:8px 12px;border:none;background:transparent;color:#f3e9d8;
      border-radius:7px;cursor:pointer;font-size:13px;min-height:38px;}
    .pintu-seg button.active{background:#c8792b;color:#fff;}

    /* 开关 toggle */
    .pintu-switch{position:relative;display:inline-block;width:48px;height:28px;cursor:pointer;flex:none;}
    .pintu-switch input{opacity:0;width:0;height:0;position:absolute;}
    .pintu-switch i{position:absolute;inset:0;background:rgba(255,255,255,.22);border-radius:14px;transition:background .2s;}
    .pintu-switch i::before{content:'';position:absolute;left:3px;top:3px;width:22px;height:22px;
      background:#fff;border-radius:50%;transition:transform .2s;box-shadow:0 1px 3px rgba(0,0,0,.3);}
    .pintu-switch input:checked + i{background:#c8792b;}
    .pintu-switch input:checked + i::before{transform:translateX(20px);}

    /* ===== 移动端适配（窄屏） ===== */
    @media (max-width: 768px) {
      .pintu-toolbar{overflow-x:auto;gap:8px;padding:4px 8px;
        padding-top:max(4px,env(safe-area-inset-top));height:auto;min-height:52px;
        scrollbar-width:none;}
      .pintu-toolbar::-webkit-scrollbar{display:none;}
      .pintu-toolbar label{display:flex;align-items:center;gap:5px;min-height:40px;padding:0 8px;font-size:12px;}
      .pintu-toolbar .stat{min-width:auto;font-size:12px;}
      .pintu-toolbar select,.pintu-toolbar button{padding:8px 10px;min-height:40px;font-size:13px;}
      .pintu-toolbar input[type=checkbox]{width:20px;height:20px;}
      .pintu-progress{width:56px;}
      /* 工具栏状态两行、操作按钮等大 */
      .pintu-status{flex-direction:column;align-items:flex-start;gap:1px;}
      .pintu-stat-line{font-size:11px;}
      .pintu-progress-wrap{display:none;}
      .pintu-actions{flex:1;gap:6px;}
      .pintu-actions .pintu-act{flex:1;min-height:40px;padding:8px 2px;font-size:13px;text-align:center;}
      .pintu-gallery{padding-bottom:max(10px,env(safe-area-inset-bottom));}
      .pintu-preview{padding-bottom:calc(96px + env(safe-area-inset-bottom));}
      .pintu-card{padding:22px 24px;}
      .pintu-card .nums{gap:18px;}
      .pintu-toast{bottom:calc(96px + env(safe-area-inset-bottom));}
    }
  `;
  document.head.appendChild(style);
}
